import router from './router'
import useOrderStore from './store'
import OrderMessages from './localization'

export default {
  router,
  useOrderStore,
  localization: OrderMessages,
}
